import { trackingMiddleware } from '@vfde-sails/tracking';
import { configureStore } from '@reduxjs/toolkit';
import appSlice from 'Container/App/slice';
import gladosApi from './container/App/api/glados';
import {
    overlayApi,
    overlaySlice,
} from '@vfde-sails/overlay';
import appListener from 'Container/App/listener';
import { validationApi } from '@vfde-sails/validation';

export const store = configureStore({
    reducer: {
        [appSlice.reducerPath]: appSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
        [overlaySlice.reducerPath]: overlaySlice.reducer,
        [overlayApi.reducerPath]: overlayApi.reducer,
        [validationApi.reducerPath]: validationApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(appListener.middleware) // Listener goes first because of special actions in it
        .concat(gladosApi.middleware, overlayApi.middleware, validationApi.middleware, trackingMiddleware),
});

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Export dispatch function
 */
export const useDispatch = () => store.dispatch;
